import { FC, PropsWithChildren } from "react";

import styles from './index.module.scss'

export const ScreenButtons: FC<PropsWithChildren<{}>> = ({ children }) => {
  return(
    <div className={styles.wrapper}>
      {children}
    </div>
  )
}